import { lazy } from "react";
import { Navigate } from "react-router-dom";

// project import
import Loadable from '@/components/Loadable';
import MainLayout from '@/layout/MainLayout';
import NotificationPage from '@/components/NotificationPage';
import Calender from '@/components/Calender';
import RecipeConfig from '@/pages/Batch-Processing/RecipeConfig';
import Batch from '@/pages/Batch-Processing/Recipe/Batch';
import Report from '@/pages/Batch-Processing/Report';
import AuditLogsReport from '@/pages/Batch-Processing/AuditLogsReport';
import ChangeControl from '@/pages/Batch-Processing/ChangeControl';
import RecipeApprovalDemo from '@/pages/Batch-Processing/RecipeApprovalDemo';
import RecipeVersioning from '@/pages/Batch-Processing/RecipeVersioning';
import StandardBlockVersioning from '@/pages/Batch-Processing/StandardBlockVersioning';
import AddIngredient from '@/pages/Batch-Processing/Recipe/AddIngredient';
import AddData from '@/pages/Batch-Processing/Recipe/AddData';
import Product from '@/pages/Batch-Processing/Recipe/Product';
import SampleTesting from '@/pages/Batch-Processing/Recipe/SampleTesting';
import BatchLogBook from '@/pages/Batch-Processing/BatchLogBook';
import CleaningLogs from '@/pages/Batch-Processing/CleaningLogs';
import EventLogs from '@/pages/Batch-Processing/EventLogs';
import EquipmentLogs from '@/pages/Batch-Processing/EquipmentLogs';
import ScheduledBatches from '@/pages/Batch-Processing/Recipe/ScheduledBatches';
import BMRTracking from '@/pages/Batch-Processing/Recipe/BMRTracking';
import Batch360 from '@/pages/Batch-Processing/Recipe/Batch360';
import AddSample from '@/pages/Batch-Processing/Recipe/AddSample';
import ReportSkeleton from '@/pages/Batch-Processing/ReportSkeleton';
import ReportTemplateConfig from '@/pages/Batch-Processing/Configurations/ReportTemplateConfig';
import UserConfig2 from '@/pages/Batch-Processing/Configurations/UserConfig2';
import UserManagementDashboard from '@/pages/Batch-Processing/Configurations/UserManagementDashboard';
import TrainingConfiguration from '@/pages/Batch-Processing/Configurations/TrainingConfiguration';
import CompanySettings from '@/pages/Batch-Processing/Configurations/CompanySettings';
import ShiftManagement from '@/pages/Batch-Processing/Configurations/ShiftManagement';
import Approvals from '@/pages/Batch-Processing/Recipe/Approvals';
import GenerateQRs from '@/pages/Batch-Processing/Configurations/GenerateQRs';
import Shift from '@/pages/Batch-Processing/shift-details/Shift';
import EmployeeAvailability from '@/pages/Batch-Processing/shift-details/EmployeeAvailability';
import EmployeePreferences from '@/pages/Batch-Processing/shift-details/EmployeePreferences';
import DAGFlowCopy from '@/pages/dashboard/ArchiMateFlow';
import ScheduleNotificationPage from '@/components/ScheduleNotificationPage';
import AlertNotificationPage from '@/components/AlertNotificationPage';
import Sensor from '@/pages/Batch-Processing/Configurations/SensorView';
import SensorMonitoringDashboard from '@/components/sensors/SensorMonitoringDashboard';
import ProcessEdit from '@/pages/Batch-Processing/Recipe/EditProcess';
import { accessControlUtils } from '@/components/AccessControlUtils';
import Graph from '@/pages/Batch-Processing/Configurations/Graph';
import Graph_new from '@/pages/Batch-Processing/Configurations/Graph_new';
import LineClearence from '@/pages/Batch-Processing/Configurations/BmrCheck';
import TicketDetails from '@/pages/Batch-Processing/TicketDetails';
import ApproveRequest from '@/pages/Batch-Processing/ApproveRequest';
import ReviewException from '@/pages/Batch-Processing/ReviewException';
import StandardChecklist from '@/pages/Batch-Processing/StandardChecklist';
import LineClearance from '@/pages/Batch-Processing/LineClearance';
import PackagingLogs from '@/pages/Batch-Processing/Recipe/Packaging/PackagingLog';
import PackDispatchLogs from '@/pages/Batch-Processing/Recipe/Packaging/DispatchHistory';
import CheckCleaning from '@/pages/Batch-Processing/Recipe/CheckCleaning';
import CleaningTypes from '@/pages/Batch-Processing/Configurations/CleaningTypes';
import ProcessControlConfig from '@/pages/Batch-Processing/Configurations/ProcessControlConfig';
import MBMR from '@/pages/Batch-Processing/mbmr/Main';
import PlantSelection from '@/pages/LandingPage/PlantSelection';
// render - dashboard
const DashboardDefault = Loadable(lazy(() => import("@/pages/dashboard")));

const Dash = Loadable(
  lazy(() => import("@/pages/dashboard/GrafanaDashboard1.js"))
);
// const MachineDetails = Loadable(lazy(() => import('@/pages/Preventive-maintenance/machine-details/MachineDetails')));

const AddRecipe = Loadable(lazy(() => import("@/pages/Batch-Processing/Recipe")));

const AddNRecipe = Loadable(
  lazy(() => import("@/pages/Batch-Processing/Recipe/AddRecipeNew"))
);

const Scheduling = Loadable(
  lazy(() => import("@/pages/Batch-Processing/Recipe/Scheduling"))
);

const UserConfig = Loadable(
  lazy(() => import("@/pages/Batch-Processing/Configurations/UserConfig"))
);


const PlantConfiguration = Loadable(
  lazy(() => import("@/pages/Administration/PlantConfiguration"))
);

const HierarchyDefinition = Loadable(
  lazy(() => import("@/pages/Administration/LocationNodePage"))
);
const HierarchyLevelsDefinition = Loadable(
  lazy(() => import("@/pages/Administration/LocationLevelSetupPage"))
);

const Result = Loadable(
  lazy(() => import("@/pages/Batch-Processing/Recipe/Result"))
);

const RunJob = Loadable(
  lazy(() => import("@/pages/Batch-Processing/Recipe/RunJob"))
);

const AddRecipeForm = Loadable(
  lazy(() => import("@/pages/Batch-Processing/Recipe/AddRecipeForm"))
);

const AllProcessesByRecipeId = Loadable(
  lazy(() => import("@/pages/Batch-Processing/Recipe/PendingRecipe"))
);

const RecipeMetaData = Loadable(
  lazy(() => import("@/pages/Batch-Processing/Recipe/RecipeMetaData"))
);

const ApproveProcess = Loadable(
  lazy(() => import("@/pages/Batch-Processing/ApproveProcess"))
);
//const Audit = Loadable(lazy(() => import("@/pages/Batch-Processing/Audit")));
const Audit = Loadable(
  lazy(() => import("@/pages/Batch-Processing/AuditReport"))
);

const ChangeHistoryAudit = Loadable(
  lazy(() => import("@/pages/Batch-Processing/ChangeHistoryAudit"))
);

const UserProfile = Loadable(lazy(() => import("@/components/UserProfile")));

const BOM = Loadable(lazy(() => import("@/pages/Batch-Processing/BOM")));
const BalanceMaterial = Loadable(
  lazy(() => import("@/pages/Batch-Processing/MaterialBalance"))
);
const EditBatch = Loadable(
  lazy(() => import("@/pages/Batch-Processing/Recipe/EditBatch"))
);
const UrlsConfig = Loadable(
  lazy(() => import("@/pages/Batch-Processing/Configurations/UrlsConfig"))
);
const ProductConfig = Loadable(
  lazy(() => import("@/pages/Batch-Processing/Configurations/Product"))
);
const Inventory = Loadable(
  lazy(() => import("@/pages/Batch-Processing/Configurations/Inventory"))
);
const Equipment = Loadable(
  lazy(() => import("@/pages/Batch-Processing/Configurations/Equipment"))
);
const SampleConfig = Loadable(
  lazy(() => import("@/pages/Batch-Processing/Configurations/SampleConfig"))
);
const Machine = Loadable(
  lazy(() => import("@/pages/Batch-Processing/Configurations/MachineEnhanced"))
);
const MachineTypeConfig = Loadable(
  lazy(() => import("@/pages/Batch-Processing/Configurations/MachineTypeConfig"))
);
const Parameter = Loadable(
  lazy(() => import("@/pages/Batch-Processing/Configurations/Parameter"))
);
const ControlCategoryConfig = Loadable(
  lazy(() => import("@/pages/Batch-Processing/Configurations/ControlCategoryConfig"))
);
const ProcessControlParameterConfig = Loadable(
  lazy(() => import("@/pages/Batch-Processing/Configurations/ProcessControlParameterConfig"))
);

const TransferPathConfig = Loadable(
  lazy(() => import("@/pages/Batch-Processing/Configurations/TransferPathConfig"))
);
const Licence = Loadable(
  lazy(() => import("@/pages/Batch-Processing/Configurations/LicenceConfig"))
);
const RecipeApproval = Loadable(
  lazy(() => import("@/pages/Batch-Processing/Recipe/RecipeApproval"))
);

const DcsConfig = Loadable(
  lazy(() => import("@/pages/Batch-Processing/Configurations/DcsConfig"))
);

const RecipeView = Loadable(
  lazy(() => import("@/pages/Batch-Processing/Recipe/ViewRecipe"))
);

const PendingRecipe = Loadable(
  lazy(() => import("@/pages/Batch-Processing/Recipe/PendingRecipe"))
);
const ProcessApproval = Loadable(
  lazy(() => import("@/pages/Batch-Processing/ApproveProcess"))
);
const ProdRecipeApproval = Loadable(
  lazy(() => import("@/pages/Batch-Processing/ProdRecipeApproval"))
);
const OperationApproval = Loadable(
  lazy(() => import("@/pages/Batch-Processing/Recipe/OperationApproval"))
);
const ProcessApprovalDetail = Loadable(
  lazy(() => import("@/pages/Batch-Processing/Recipe/ProcessApprovalDetail"))
);
const ArchiveRecipe = Loadable(
  lazy(() => import("@/pages/Batch-Processing/Recipe/ArchiveRecipe"))
);

const ApplicationSettings = Loadable(
  lazy(() =>
    import("@/pages/Batch-Processing/Configurations/ApplicationSettings")
  )
);
const DynamicFlow = Loadable(
  lazy(() => import("@/pages/Batch-Processing/flow/DynamicFlow"))
);

const StandardBlockForm = Loadable(
  lazy(() => import("@/pages/Batch-Processing/Recipe/StandardBlockForm"))
);

const RulesConfig = Loadable(
  lazy(() => import("@/pages/Batch-Processing/Rules/RulesConfig"))
);

const RulesForm = Loadable(
  lazy(() => import("@/pages/Batch-Processing/Rules/RulesForm"))
);

const IngredientsRules = Loadable(
  lazy(() => import("@/pages/Batch-Processing/Rules/IngredientsRules"))
);

const MonitoringRules = Loadable(
  lazy(() => import("@/pages/Batch-Processing/Rules/MonitoringRules"))
);

const SamplingRules = Loadable(
  lazy(() => import("@/pages/Batch-Processing/Rules/SamplingRules"))
);

const ProductRules = Loadable(
  lazy(() => import("@/pages/Batch-Processing/Rules/ProductRules"))
);

const ActionListRules = Loadable(
  lazy(() => import("@/pages/Batch-Processing/Rules/ActionListRules"))
);

const ChecklistRules = Loadable(
  lazy(() => import("@/pages/Batch-Processing/Rules/ChecklistRules"))
);

const LineClearanceRules = Loadable(
  lazy(() => import("@/pages/Batch-Processing/Rules/LineClearanceRules"))
);

const APICalculationRules = Loadable(
  lazy(() => import("@/pages/Batch-Processing/Rules/APICalculationRules"))
);

const MachineSetupRules = Loadable(
  lazy(() => import("@/pages/Batch-Processing/Rules/MachineSetupRules"))
);

const PackagingConfig = Loadable(
  lazy(() => import("@/pages/Batch-Processing/Recipe/Packaging/PackagingConfig"))
);
const ViewPackRecipe = Loadable(
  lazy(() =>
    import("@/pages/Batch-Processing/Recipe/Packaging/ViewPackageRecipe")
  )
);

const ProcessManage = Loadable(
  lazy(() =>
    import("@/pages/Batch-Processing/Recipe/Packaging/ProcessManagement")
  )
);

const ContineousProd = Loadable(
  lazy(() => import("@/components/ContinuousProduction"))
);

// Add the FormBuilder with Loadable wrapper
const FormBuilder = Loadable(
  lazy(() => import("@/pages/Batch-Processing/Configurations/FormBuilder"))
);

const StandardBlockDetails = Loadable(
  lazy(() =>
    import("@/pages/Batch-Processing/Configurations/StandarBlockDetails")
  )
);

const RefillingLogs = Loadable(
  lazy(() => import("@/pages/Batch-Processing/Configurations/RefillingLogs"))
);

const WorkflowProgress = Loadable(
  lazy(() =>
    import("@/pages/Batch-Processing/Recipe/PharmaFlow/ProductionWorkflow")
  )
);
const AreaSelection = Loadable(
  lazy(() => import("@/pages/Batch-Processing/Recipe/PharmaFlow/AreaSelection"))
);

const AreaConfig = Loadable(
  lazy(() =>
    import("@/pages/Batch-Processing/Recipe/PharmaFlow/AreaConfiguration")
  )
);

const AllProcessFlow = Loadable(
  lazy(() =>
    import("@/pages/Batch-Processing/Recipe/PharmaFlow/DispensingWorkflow")
  )
);

const InitialProdFlow = Loadable(
  lazy(() => import("@/pages/Batch-Processing/Recipe/PharmaFlow/InitialProdFlow"))
);

const ProcessOverview = Loadable(
  lazy(() => import("@/pages/Batch-Processing/Recipe/PharmaFlow/ProcessOverview"))
);
const WorkflowBuilder = Loadable(
  lazy(() => import("@/pages/Batch-Processing/flow/WorkFlowNew"))
);
const MBMRDashboard = Loadable(
  lazy(() => import("@/pages/dashboard/dashboard_data/RoleBasedDashboard"))
);
const RoomConfig = Loadable(
  lazy(() =>
    import("@/pages/Batch-Processing/Configurations/RoomWithBoothsConfig")
  )
);

const MasterDataConfig = Loadable(
  lazy(() =>
    import("@/pages/Batch-Processing/Configurations/MasterDataConfig")
  )
);

const OperationTypeConfig = Loadable(
  lazy(() =>
    import("@/pages/Batch-Processing/Configurations/OperationTypeConfig")
  )
);

// New MBMRConfig page Changes

const MBMRConfig = Loadable(
  lazy(() => import("@/pages/Batch-Processing/MBMRConfig"))
);

const Workflow = Loadable(lazy(() => import("@/pages/workflow-creation/index")));

const WorkflowsList = Loadable(
  lazy(() => import("@/pages/workflow-creation/WorkflowsList"))
);

const UpdateWorkflow = Loadable(
  lazy(() => import("@/pages/workflow-creation/UpdateWorkflow"))
);

const FormTemp = Loadable(lazy(() => import("@/pages/dynamic-form")));

const CreateForm = Loadable(
  lazy(() => import("@/pages/dynamic-form/CreateForm"))
);

const TicketList = Loadable(lazy(() => import("@/pages/ticket/TicketList")));

const TicketCreation = Loadable(
  lazy(() => import("@/pages/ticket/ticket-creation"))
);

const TicketMainpage = Loadable(
  lazy(() => import("@/pages/ticket/TicketMainpage"))
);

const EBMRControlCharts = Loadable(
  lazy(() => import("@/pages/ticket/eBMRControlCharts"))
);

const DetailsPage = Loadable(lazy(() => import("@/pages/DetailsPage")));

const ViewForm = Loadable(lazy(() => import("@/pages/dynamic-form/ViewForm")));

const TestTypeField = Loadable(
  lazy(() => import("@/pages/Batch-Processing/Configurations/AddTestType"))
);

const ApiCalcField = Loadable(
  lazy(() => import("@/pages/Batch-Processing/Configurations/ApiCalcField"))
);
const ClearanceType = Loadable(
  lazy(() => import("@/pages/Batch-Processing/Configurations/ClearanceType"))
);
const SystemIntegration = Loadable(
  lazy(() =>
    import("@/pages/Batch-Processing/MBMRConfig/ExternalSystemIntegration")
  )
);

const WorkflowAutomation = Loadable(
  lazy(() => import("@/pages/workflow-automation/WorkflowAutomation"))
);

const WorkflowAutomationBuilder = Loadable(
  lazy(() => import("@/pages/workflow-automation/WorkflowBuilder"))
);

const GenealogyTree = Loadable(
  lazy(() => import("@/components/genealogy/GenealogyTree"))
);

const RecallAnalysis = Loadable(
  lazy(() => import("@/components/genealogy/RecallAnalysis"))
);

const BatchGenealogyFull = Loadable(
  lazy(() => import("@/pages/Batch-Processing/BatchGenealogy"))
);

// ==============================|| MAIN ROUTING ||============================== //
const accessData = (module) => {
  return accessControlUtils(module)?.read_access;
};

const ActionListField = Loadable(
  lazy(() => import("@/pages/Batch-Processing/Configurations/ActionListField"))
);


const MainRoutes = () => {
  return {
    path: "/",
    element: <MainLayout />,
    children: [
      {
        path: "/",
        element: <Dash />,
      },
      {
        path: "/dash",
        element: <Dash />,
      },
      {
        path: "/user-profile",
        element: <UserProfile />,
      },
      {
        path: "/viewRecipe",
        element: <RecipeConfig />,
      },
      {
        path: "/scheduling",
        element: <Scheduling />,
      },
      {
        path: "/result",
        element: <Report />,
      },
      {
        path: "/approve-request",
        element: <ApproveRequest />,
      },
      {
        path: "/review-exception",
        element: <ReviewException />,
      },
      {
        path: "/standard-checklist",
        element: <StandardChecklist />,
      },
      {
        path: "/line-clearance",
        element: <LineClearance />,
      },
      {
        path: "/ticket-details",
        element: <TicketDetails />,
      },
      {
        path: "/report",
        element: <ReportSkeleton />,
      },
      {
        path: "/audit-logs",
        element: <AuditLogsReport />,
      },
      {
        path: "/change-control",
        element: <ChangeControl />,
      },
      {
        path: "/recipe-versioning",
        element: <RecipeVersioning />,
      },
      {
        path: "/standard-block-versioning",
        element: <StandardBlockVersioning />,
      },
      {
        path: "/recipe-approval-workflow",
        element: <RecipeApprovalDemo />,
      },
      {
        path: "/report-template-config",
        element: <ReportTemplateConfig />,
      },
      {
        path: "/batches",
        element: <ScheduledBatches />,
      },
      {
        path: "/bmr-tracking",
        element: <BMRTracking />,
      },
      {
        path: "/batch-traceability",
        element: <Batch360 />,
      },
      {
        path: "/userConfig",
        element: <UserConfig2 />,
      },
      {
        path: "/user-management",
        element: <UserManagementDashboard />,
      },
      {
        path: "/training-configuration",
        element: <TrainingConfiguration />,
      },
      {
        path: "/company-settings",
        element: <CompanySettings />,
      },
      {
        path: "/shift-management",
        element: <ShiftManagement />,
      },
      {
        path: "/formBuilder",
        element: <FormBuilder />,
      },
      {
        path: "/addRecipeForm",
        element: <AddRecipeForm />,
      },
      {
        // Access Control moved into the role dialog (User Management > Roles & Permissions).
        path: "/accessControl",
        element: <Navigate to="/user-management" replace />,
      },
      {
        path: "/plant-configuration",
        element: <PlantConfiguration />,
      },
      {
        path: "/hierarchy-definition",
        element: <HierarchyDefinition />,
      },
      {
        path: "/hierarchy-levels",
        element: <HierarchyLevelsDefinition />,
      },
      {
        path: "/batch",
        element: <Batch />,
      },
      {
        path: "/sample-testing",
        element: <SampleTesting />,
      },
      {
        path: "/batch-logbook",
        element: <BatchLogBook />,
      },
      {
        path: "/cleaning-logs",
        element: <CleaningLogs />,
      },
      {
        path: "/equipment-logs",
        element: <EquipmentLogs />,
      },
      {
        path: "/ingredients",
        element: <AddIngredient />,
      },
      {
        path: "/parameters",
        element: <AddData />,
      },
      {
        path: "/product",
        element: <Product />,
      },
      {
        path: "/sampling",
        element: <AddSample />,
      },
      {
        path: "/notifications",
        element: <NotificationPage />,
      },
      {
        path: "/calender",
        element: <Calender />,
      },
      {
        path: "/processesApproval",
        element: <AllProcessesByRecipeId />,
      },
      {
        path: "/recipeMetadata",
        element: <RecipeMetaData />,
      },
      {
        path: "/approveProcess",
        element: <ApproveProcess />,
      },
      {
        path: "/batch-approval",
        element: <Approvals />,
      },
      {
        path: "/audit-report",
        element: <Audit />,
      },
      {
        path: "/change-history-audit",
        element: <ChangeHistoryAudit />,
      },
      {
        path: "/check-cleaning",
        element: <CheckCleaning />,
      },

      {
        path: "/sensor",
        element: <Sensor />,
      },
      {
        path: "/sensor-monitoring",
        element: <SensorMonitoringDashboard />,
      },
      {
        path: "/bom",
        element: <BOM />,
      },
      {
        path: "/bal-material",
        element: <BalanceMaterial />,
      },
      {
        path: "/recipe-approval",
        element: <RecipeApproval />,
      },
      {
        path: "/generate-qr",
        element: <GenerateQRs />,
      },
      {
        path: "/shift-details",
        element: <Shift />,
      },
      {
        path: "/employee-availability",
        element: <EmployeeAvailability />,
      },
      {
        path: "/employee-preferences",
        element: <EmployeePreferences />,
      },
      {
        path: "/messages",
        element: <ScheduleNotificationPage />,
      },
      {
        path: "/alert-notify",
        element: <AlertNotificationPage />,
      },
      {
        path: "/dag-flow",
        element: <DAGFlowCopy />,
      },
      {
        path: "/edit-batch",
        element: <EditBatch />,
      },

      {
        path: "/url-config",
        element: <UrlsConfig />,
      },
      {
        path: "/material-config",
        element: <Inventory />,
      },
      {
        path: "/prod-config",
        element: <ProductConfig />,
      },
      {
        path: "/equipment-config",
        element: <Equipment />,
      },
      {
        path: "/sample-config",
        element: <SampleConfig />,
      },
      {
        path: "/machine-config",
        element: <Machine />,
      },
      {
        path: "/machine-type-config",
        element: <MachineTypeConfig />,
      },
      {
        path: "/dcs-config",
        element: <DcsConfig />,
      },
      {
        path: "/param-config",
        element: <Parameter />,
      },
      {
        path: "/transfer-path-config",
        element: <TransferPathConfig />,
      },
      {
        path: "/process-control-config",
        element: <ProcessControlConfig />,
      },
      {
        path: "/control-category-config",
        element: <ControlCategoryConfig />,
      },
      {
        path: "/process-control-parameter-config",
        element: <ProcessControlParameterConfig />,
      },
      {
        path: "/licence-config",
        element: <Licence />,
      },

      {
        path: "/edit-process",
        element: <ProcessEdit />,
      },
      {
        path: "/event-logs",
        element: <EventLogs />,
      },
      {
        path: "/recipe-view",
        element: <RecipeView />,
      },
      {
        path: "/pendingRecipe",
        element: <PendingRecipe />,
      },
      {
        path: "/processApproval",
        element: <ProcessApproval />,
      },
      {
        path: "/processApproval/:process_id",
        element: <ProcessApprovalDetail />,
      },
      {
        path: "/operation-approval",
        element: <OperationApproval />,
      },
      {
        path: "/prod-recipe-approval",
        element: <ProdRecipeApproval />,
      },
      {
        path: "/archive-recipe",
        element: <ArchiveRecipe />,
      },
      {
        path: "/app-setting",
        element: <ApplicationSettings />,
      },

      {
        path: "/graph-new",
        element: <Graph_new />,
      },
      {
        path: "/graph",
        element: <Graph />,
      },
      {
        path: "/line-clearence",
        element: <LineClearence />,
      },
      {
        path: "/dynamic-flow",
        element: <DynamicFlow />,
      },
      {
        path: "/standard-block",
        element: <StandardBlockDetails />,
      },
      {
        path: "/pack-config",
        element: <PackagingConfig />,
      },
      {
        path: "/pack-mbpr",
        element: <ViewPackRecipe />,
      },
      {
        path: "/mbpr-log",
        element: <PackagingLogs />,
      },
      {
        path: "/dispatch-logs",
        element: <PackDispatchLogs />,
      },
      {
        path: "/process_manage",
        element: <ProcessManage />,
      },
      {
        path: "/continuous_prod",
        element: <ContineousProd />,
      },
      {
        path: "/standard-form",
        element: <StandardBlockForm />,
      },
      {
        path: "/rules",
        element: <RulesConfig />,
      },
      {
        path: "/rules-form",
        element: <RulesForm />,
      },
      {
        path: "/rules/ingredients",
        element: <IngredientsRules />,
      },
      {
        path: "/rules/monitoring",
        element: <MonitoringRules />,
      },
      {
        path: "/rules/sampling",
        element: <SamplingRules />,
      },
      {
        path: "/rules/product",
        element: <ProductRules />,
      },
      {
        path: "/rules/action-list",
        element: <ActionListRules />,
      },
      {
        path: "/rules/checklist",
        element: <ChecklistRules />,
      },
      {
        path: "/rules/line-clearance",
        element: <LineClearanceRules />,
      },
      {
        path: "/rules/api-calculation",
        element: <APICalculationRules />,
      },
      {
        path: "/rules/machine-setup",
        element: <MachineSetupRules />,
      },
      {
        path: "/refilling-logs",
        element: <RefillingLogs />,
      },
      { path: "/mbmr-dash", element: <MBMRDashboard /> },
      { path: "/WorkflowProgress", element: <WorkflowProgress /> },
      { path: "/areaSelection", element: <AreaSelection /> },
      { path: "/areaConfig", element: <AreaConfig /> },
      { path: "/processFlow", element: <AllProcessFlow /> },
      { path: "/initialProdFlow", element: <InitialProdFlow /> },
      { path: "/processOverview", element: <ProcessOverview /> },
      { path: "/cleaningTypes", element: <CleaningTypes /> },
      { path: "/workFlowBuilder", element: <WorkflowBuilder /> },
      { path: "/roomConfig", element: <RoomConfig /> },
      { path: "/master-config", element: <MasterDataConfig /> },
      {
        path: "/mbmr",
        element: <MBMR />,
      },
      {
        path: "/process-config/:recipe_id",
        element: <MBMRConfig />,
      },
      {
        path: "/operation-type",
        element: <OperationTypeConfig />,
      },
      {
        path: "/workflow-creation/",
        element: <Workflow />,
      },
      {
        path: "/workflow-creation/:id",
        element: <Workflow />,
      },
      {
        path: "/work-flow",
        element: <WorkflowsList />,
      },
      {
        path: "/workflow-update/:workflow_id",
        element: <UpdateWorkflow />,
      },
      {
        path: "/form",
        element: <FormTemp />,
      },
      {
        path: "/form-details/:id",
        element: <CreateForm />,
      },
      {
        path: "/view-form/:id",
        element: <ViewForm />,
      },
      {
        path: "/ticket",
        element: <TicketList />,
      },
      {
        path: "/ticket-creation",
        element: <TicketCreation />,
      },
      {
        path: "/ticket/:id",
        element: <TicketMainpage />,
      },
      {
        path: "/ebmr-control-charts",
        element: <EBMRControlCharts />,
      },
      {
        path: "/AllDetails",
        element: <DetailsPage />,
      },
      {
        path: "/actionListFields",
        element: <ActionListField />,
      },
      {
        path: "/test-type",
        element: <TestTypeField />,
      },
      {
        path: "/apicalc-field",
        element: <ApiCalcField />,
      },
      {
        path: "/clearance-type",
        element: <ClearanceType />,
      },
      {
        path: "/system-integration",
        element: <SystemIntegration />,
      },
      {
        path: "/plant-select",
        element: <PlantSelection />,
      },
      {
        path: "/workflow-automation/create",
        element: <WorkflowAutomationBuilder />,
      },
      {
        path: "/workflow-automation/edit/:id",
        element: <WorkflowAutomationBuilder />,
      },
      {
        path: "/workflow-automation",
        element: <WorkflowAutomation />,
      },
      {
        path: "/batch-genealogy",
        element: <GenealogyTree />,
      },
      {
        path: "/batch-genealogy-full",
        element: <BatchGenealogyFull />,
      },
      {
        path: "/recall-analysis",
        element: <RecallAnalysis />,
      },
    ].filter(Boolean),
  };
};

export default MainRoutes;
